import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import Login from './Login';
import PortfolioManager from './PortfolioManager';
import './Dashboard.css';

const Dashboard = () => {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('portfolio');

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>{t('admin.dashboard')}</h1>
        <div className="dashboard-nav">
          <button
            className={activeTab === 'portfolio' ? 'active' : ''}
            onClick={() => setActiveTab('portfolio')}
          >
            {t('admin.portfolio.title')}
          </button>
          <button
            onClick={logout}
            className="logout-button"
          >
            {t('admin.logout')}
          </button>
        </div>
      </header>

      <main className="dashboard-content">
        {activeTab === 'portfolio' && <PortfolioManager />}
      </main>
    </div>
  );
};

export default Dashboard;
